
























































































import ModuleBindings from '@/includes/logic/Modules/mixins/ModuleBindings'
import { InputSetups } from "@/mixins/input-setups";
import { StickerMessageTypeEnum } from "@/includes/logic/Modules/modules/modules/StickerFilterHandlerModule/types";
import StickerFilterHandlerModuleBuilder
  from "@/includes/logic/Modules/modules/modules/StickerFilterHandlerModule/StickerFilterHandlerModuleBuilder";

import ModuleConfigSettings from '../../../components/ModuleConfigSettings.vue'
import ModuleConfigSettingsWrapper from '../../../components/ModuleConfigSettingsWrapper.vue'
import FilterJournal from "../../../components/filters/FilterJournal.vue";
import FilterCommonSettings from "../../../components/filters/FilterCommonSettings.vue";
import FilterNewUsersSettings from "../../../components/filters/FilterNewUsersSettings.vue";
import FilterRemoveEditedSetting from "../../../components/filters/FilterRemoveEditedSetting.vue";
import FilterExtraSettings from "../../../components/filters/FilterExtraSettings.vue";
import FilterResetPunishSettings from '../../../components/filters/FilterResetPunishSettings.vue'
import FilterSettingLayout from "../../../components/filters/layout/FilterSettingLayout.vue";

import { SelectOption } from "piramis-base-components/src/logic/types";
import SelectInput from 'piramis-base-components/src/components/Pi/fields/SelectInput/SelectInput.vue';

import { Component, Mixins, VModel } from 'vue-property-decorator'

@Component({
  components: {
    FilterSettingLayout,
    FilterExtraSettings,
    FilterRemoveEditedSetting,
    FilterResetPunishSettings,
    FilterNewUsersSettings,
    FilterCommonSettings,
    FilterJournal,
    SelectInput,
    ModuleConfigSettingsWrapper,
    ModuleConfigSettings,
  },
})
export default class StickerFilterHandlerModuleView extends Mixins(ModuleBindings, InputSetups) {
  @VModel() module!: StickerFilterHandlerModuleBuilder

  get messageTypeOptions(): Array<SelectOption> {
    return [
      {
        label: this.$t(`${ this.module.model.snakeCaseType }_message_type_all`).toString(),
        value: StickerMessageTypeEnum.All
      },
      {
        label: this.$t(`${ this.module.model.snakeCaseType }_message_type_without_sticker_pack`).toString(),
        value: StickerMessageTypeEnum.WithoutStickerPack
      },
      {
        label: this.$t(`${ this.module.model.snakeCaseType }_message_type_without_sticker_pack_or_emoji`).toString(),
        value: StickerMessageTypeEnum.WithoutStickerPackOrEmoji
      }
    ]
  }
}
